export const ROUTE_CALENDAR = 'calendar';

export const ROUTE_COACH = 'coach';
export const ROUTE_COACH_PHONE = 'coach.phone';

export const ROUTE_COURSE_BOOT_TRAINERS = 'course.boot.trainers';
export const ROUTE_COURSE_BOOT_TRAINER = 'course.boot.trainer';
export const ROUTE_COURSE_CREATE = 'course.create';
export const ROUTE_COURSE_CREATE_WEEKDAYS = 'course.create.weekdays';
export const ROUTE_COURSE_CREATE_PROGRAMS = 'course.create.programs';
export const ROUTE_COURSE_CREATE_BULKING_OPTIONS = 'course.create.bulking_options';
export const ROUTE_COURSE_VIEW = 'course.view';
export const ROUTE_COURSE_VIEW_WEEKDAYS = 'course.view.weekdays';
export const ROUTE_COURSE_VIEW_PROGRAMS = 'course.view.programs';
export const ROUTE_COURSE_VIEW_BULKING_OPTIONS = 'course.view.bulking_options';
export const ROUTE_PERIODIC_COURSE_EDITING = 'course.editing';
export const ROUTE_PERIODIC_COURSE_DELETING = 'course.deleting';
export const ROUTE_COURSE_NOTIFICATION = 'course.notification';

export const ROUTE_GUIDE = 'guide';

export const ROUTE_INVITE = 'invite';

export const ROUTE_LOGIN = 'login';
export const ROUTE_LOGIN_PHONE = 'login.phone';
export const ROUTE_LOGIN_GUIDE = 'login.guide';

export const ROUTE_TRAINER_LIST = 'trainer.list';
export const ROUTE_TRAINER_CREATE = 'trainer.create';
export const ROUTE_TRAINER_VIEW = 'trainer.view';
export const ROUTE_TRAINER_VIEW_UNBOUND = 'trainer.view.unbound';
export const ROUTE_TRAINER_VIEW_BOUND = 'trainer.view.bound';
export const ROUTE_TRAINER_NICKNAME = 'trainer.nickname';

export const ROUTE_WECHAT_AUTHORIZE = 'wechat.authorize';
export const ROUTE_WECHAT_CALLBACK = 'wechat.callback';

export const ROUTE_SHARE_BRIDGE = 'share.bridge';



// WEBPACK FOOTER //
// ./src/router/names.js